<template lang="pug">
  ul.mt0.list-reset.sticky-list
    li.mb2.sticky-item(v-for="item, idx in data", :key="item.id")
      .primary-info
        a(:href="item.origin_url", target="_blank")
          .mt0.mb1.item-title(:title="item.title", data-clamp="3") {{ item.title }}
        .sub
          | {{ item.pub_source }}
          span.px1 |
          | {{ formatUtc(item.pub_utc) }}
      .primary-img
        a(:href="item.origin_url", target="_blank")
          img.fit(:src="shift(item.o_pic_list[0])")
</template>

<script>
import moment from "moment";
import transformImgLink from "@/assets/utils/transformImgLink";
export default {
  props: ["data"],
  methods: {
    shift(link) {
      return transformImgLink(link);
    },
    formatUtc(utc) {
      return moment.unix(utc).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';
.sticky-list
  .primary-img
    height 0
    overflow hidden
    transition height 1s ease-out
  .sticky-item:hover
    .primary-img
      height 150px
      transition-delay .5s
</style>



// WEBPACK FOOTER //
// StickyList.vue?5779c3af